// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3sAZR","header":"PatientBlock_header__16AOx","label":"PatientBlock_label__Cgkgb","option":"PatientBlock_option__1nwsn"};